import { render, staticRenderFns } from "./EncuestaForm.vue?vue&type=template&id=b4815ade&"
import script from "./EncuestaForm.vue?vue&type=script&lang=js&"
export * from "./EncuestaForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports